// main.js
import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure
import Vue from "vue";
import Vuetify from "vuetify/lib";
import customIcon from "@/assets/customIcon";

Vue.use(Vuetify, {
  iconfont: "mdi"
});

export default new Vuetify({
  icons: {
    iconfont: "mdi",
    values: {
      custom: {
        // name of our custom icon
        component: customIcon // our custom component
      }
    }
  }
});
